import _regeneratorRuntime from '/var/www/html/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/var/www/html/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//


import axios from 'axios';

export default {
    name: "choose-package",
    data: function data() {
        return {
            results: {}
        };
    },
    asyncData: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
            var route = _ref.route;

            var _ref3, data;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return axios.get(global.websiteSettings.extra_info.api_endpoint + 'api/payment/package/' + route.params.id);

                        case 2:
                            _ref3 = _context.sent;
                            data = _ref3.data;
                            return _context.abrupt('return', {
                                results: data
                            });

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function asyncData(_x) {
            return _ref2.apply(this, arguments);
        }

        return asyncData;
    }(),

    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        }
    },
    created: function created() {
        if (this.results.url) {
            window.location = this.results.url;
        } else {
            if (flash) flash(this.$root.trans('st_public.generic_error_message'), 'error');
            this.$router.push({ name: 'index', params: { lang: this.lang } });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/payment/package/_id.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/payment/package/_id.vue
// module chunks = 34